export const VISIBLE_MAX_COUNT = 3 // equals $visible-max-count

export const SIZE = {
  S: 's',
  M: 'm',
  L: 'l',
}
